import { getFormValues } from 'redux-form';
import deepMerge from 'deepmerge';
import { get } from 'lodash';

import {
  AUDIENCE_FORM_NAME,
  CAMPAIGN_FORM_NAME,
  NEW_VOICEOVER,
  PLATFORMS,
  ALL_GENDERS_VALUE,
  FREE_TRIAL_NULL_VALUE,
} from 'config';
import { getCurrency, getPaymentsErrorMessage } from './payments';
import { daysFromToday, endOfDay } from 'utils/dateHelper';
import { fillObject } from 'utilities';

import { CITY_TARGETING } from 'config/featureFlags';

import { getFlagValue } from './featureFlags';
import { getValidationForReduxForm } from './reduxForm';
import { isInternalUser } from './user';

export const getEditableAd = state => state.editableAd;

export const getAdFromCreateForms = state => ({
  ...(getFormValues(CAMPAIGN_FORM_NAME)(state) || {}),
  ...(getFormValues(AUDIENCE_FORM_NAME)(state) || {}),
});

export const getCombinedAd = state => deepMerge(
  getEditableAd(state),
  getAdFromCreateForms(state),
);

export const getCampaignInitialValues = () => ({
  internalName: '',
  objective: '',
});

export const getAudienceInitialValues = state => ({
  targeting: {
    ageRange: {
      start: '13',
      end: '65',
    },
    fanAudiences: [],
    freeTrial: FREE_TRIAL_NULL_VALUE,
    gender: ALL_GENDERS_VALUE,
    genres: [],
    locations: [],
    moments: [],
    platforms: fillObject(Object.keys(PLATFORMS), true),
  },
  dateRange: {
    begin: daysFromToday(2),
    end: endOfDay(daysFromToday(2)),
  },
  payments: {
    totalBudget: '',
    currency: getCurrency(state),
  },
  paymentsConnected: getPaymentsErrorMessage(state),
});

export const getBuildAdActiveStep = state => getEditableAd(state).activeStep;
export const getVOName = state => get(getEditableAd(state), `audioSubmission.${NEW_VOICEOVER}.name`);

export function getBuildAdValidationResultsByStep(state) {
  const { validation: { steps } } = state;

  // overwrite for redux-form validation
  const overrides = {
    1: getValidationForReduxForm(state, CAMPAIGN_FORM_NAME),
    2: getValidationForReduxForm(state, AUDIENCE_FORM_NAME),
  };

  return { ...steps, ...overrides };
}

export function getEditableAdValid(state) {
  const stepValidation = getBuildAdValidationResultsByStep(state);
  return Object.keys(stepValidation)
    .map(key => stepValidation[key])
    .every(({ touched, isValid: isStepValid }) => touched && isStepValid);
}

export function hasFreeTrialTargeting(state) {
  return isInternalUser(state);
}

export function hasCityTargeting(state) {
  return getFlagValue(state, CITY_TARGETING) === 'on';
}



// WEBPACK FOOTER //
// ./src/selectors/adCreation.js